import { Navigate, useRoutes } from "react-router-dom";
// layouts
import DashboardLayout from "./layouts/dashboard";
import SimpleLayout from "./layouts/simple";
//
import ListSurvey from "./pages/ListSurvey";
import LoginPage from "./pages/LoginPage";
import Page404 from "./pages/Page404";
import ListDealer from "./pages/ListDealer";
import DashboardAppPage from "./pages/DashboardAppPage";
import NewTicket from "./pages/NewTicket";
import ViewVistoria from "./pages/ViewVistoria";
import ListUser from "./pages/ListUsers";
import ReportFinancial from "./pages/collapseNavMenu/ReportFinancial";
import ReportSurveys from "./pages/collapseNavMenu/ReportSurveys";
import PrivateRoute from "./hooks/Token/PrivateRoute";
import ResetPassword from "./pages/resetPassword/ResetPassword";
import Profile from "./pages/Profile";
import DashboardHomePage from "./pages/DashboardHomePage";
// ----------------------------------------------------------------------

export default function Router() {
  const routes = useRoutes([
    {
      path: "/dashboard",
      element: <PrivateRoute children={<DashboardLayout />} />,
      children: [
        { element: <Navigate to="/dashboard/home" />, index: true },
        {
          path: "home",
          element: <PrivateRoute children={<DashboardHomePage />} />,
          index: true,
        },
        {
          path: "app",
          element: <PrivateRoute children={<DashboardAppPage />} />,
        },
        {
          path: "ticket/:statusParam",
          element: <PrivateRoute children={<ListSurvey />} />,
        },
        {
          path: "new-ticket",
          element: <PrivateRoute children={<NewTicket />} />,
        },
        {
          path: "view-ticket",
          element: <PrivateRoute children={<ViewVistoria />} />,
        },
        { path: "dealer", element: <PrivateRoute children={<ListDealer />} /> },
        { path: "user", element: <PrivateRoute children={<ListUser />} /> },
        {
          path: "reports/financial",
          element: <PrivateRoute children={<ReportFinancial />} />,
        },
        {
          path: "reports/surveys",
          element: <PrivateRoute children={<ReportSurveys />} />,
        },
        { path: "profile", element: <PrivateRoute children={<Profile />} /> },
      ],
    },
    {
      path: "login",
      element: <LoginPage />,
    },
    {
      path: "reset/password",
      element: <ResetPassword />,
    },
    {
      element: <SimpleLayout />,
      children: [
        { element: <Navigate to="/dashboard/home" />, index: true },
        { path: "404", element: <Page404 /> },
        { path: "*", element: <Navigate to="/404" /> },
      ],
    },
    {
      path: "*",
      element: <Navigate to="/404" replace />,
    },
  ]);

  return routes;
}
